'use strict';

angular.module('app.shared.datePickerPopup.datePickerPopupController', [])
  .controller('app.shared.datePickerPopup.datePickerPopupController', [
    '$scope',
    function ($scope) {
      $scope.rangeStart = $scope.rangeStart || null;
      $scope.rangeEnd = $scope.rangeEnd || null;
      $scope.givenDate = $scope.givenDate || null;
      $scope.startDate = $scope.startDate || null;
      $scope.disablePopup = $scope.disablePopup || null;
      $scope.dt = null;

      $scope.today = function () {
        $scope.dt = new Date();
      };

      $scope.clear = function () {
        $scope.dt = null;
      };


      $scope.dateOptions = {
        //dateDisabled: disabled,
        formatYear: 'yy',
        maxDate: $scope.rangeEnd !== null ? new Date($scope.rangeEnd) : new Date(2020, 11, 31),
        minDate: $scope.rangeStart !== null ? new Date($scope.rangeStart) : new Date(2008, 12, 1),
        startingDay: 1,
        showWeeks: false
      };

      // Disable weekend selection
      function disabled(data) {
        let date = data.date,
          mode = data.mode;
        return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
      }


      $scope.open1 = function () {
        $scope.popup1.opened = true;
      };


      /*$scope.setDate = function (year, month, day) {
        $scope.dt = month+'/'+day+'/'+year;//new Date(year, month, day);
      };*/

      $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
      $scope.format = $scope.formats[0];
      $scope.altInputFormats = ['M!/d!/yyyy', 'M!/d!/!yyyy'];

      $scope.popup1 = {
        opened: false,
      };

      $scope.$on('clear_dates', () => {
        $scope.clear();
      });

      $scope.$watch(()=> {
        return $scope.startDate;
      }, () => {
        $scope.dateOptions.initDate = $scope.startDate ? new Date($scope.startDate) : null;
      });

      $scope.$watch(function () {
        return $scope.givenDate;
      }, function () {
        if (typeof $scope.givenDate !== 'undefined') {
          $scope.clear();
          if(typeof $scope.givenDate === 'string') {
            $scope.givenDate = moment($scope.givenDate).toDate();
          }
          $scope.dt = $scope.givenDate;
        }
      });

    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/shared/datePickerPopup/datePickerPopupController.js